<template>
  <div id="app" :style="cssProps">
    <component v-bind:is="component">
      <slot></slot>
    </component>
    <transition name="fade">
      <button v-if="scrolling" id="back_to_top" class="btn btn-info" @click="scrollToTop" title="Retour en haut de la page" type="button">
        <font-awesome-icon class="icon fa-lg" icon="angle-up"/>
      </button>
    </transition>
  </div>
</template>

<script>
import LoginLayout from '@/layouts/login'
import DefaultLayout from '@/layouts/default'
import HomeLayout from '@/layouts/home'
import hexToRgba from 'hex-to-rgba'
import store from './store'

import ConfigurationService from '@/services/configurationService'

import 'animate.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'assets/font.css'
import 'assets/custom.css'
import 'assets/base.css'

export default {
  name: 'App',
  components: {
    LoginLayout,
    DefaultLayout,
    HomeLayout
  },
  data () {
    return {
      tenantCode: '',
      themeColor: 'A9A9A9',
      scrolling: false
    }
  },
  computed: {
    tenantId () {
      return store.getters.tenantId
    },
    component () {
      return store.getters.layout
    },
    cssProps () {
      return {
        '--theme-color': '#' + this.themeColor,
        '--theme-color-50': hexToRgba(
          '#' + this.themeColor,
          '0.5'
        ),
        '--theme-color-25': hexToRgba(
          '#' + this.themeColor,
          '0.25'
        )
      }
    }
  },
  watch: {
    tenantId () {
      this.loadConfiguration()
      this.initBackToTopListener()
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log('[ROOT_API]', process.env.ROOT_API)
    }
  },
  methods: {
    loadConfiguration () {
      new ConfigurationService()
        .retrieveConfiguration()
        .then(data => {
          store.dispatch('setConfiguration', data)
          this.themeColor = store.getters.configuration.themeColor
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/')
        })
    },
    initBackToTopListener () {
      window.onscroll = () => {
        this.scrolling = document.documentElement.scrollTop > 500
      }
    },
    scrollToTop () {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
body,
html {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
}

body {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

#app {
  display: flex;
  flex: 1;
  font-family: "Overpass", sans-serif;
}

#back_to_top {
  width: 3rem;
  height: 3rem;
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  border-radius: 3rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, .7);
  z-index: 200;
}

#back_to_top:hover,
#back_to_top:focus {
  border: 1px solid var(--theme-color);
  box-shadow: 0 0 20px rgba(0, 0, 0, .7);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #back_to_top:hover,
  #back_to_top:focus {
    border: 1px solid lightseagreen;
  }

  html, body {
    min-height: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue